import React from 'react';
import bigLoyalty from '../../assets/images/big_loyalty.svg';
import bigRewards from '../../assets/images/big_rewards.svg';
import Image from '../Image';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import { SubBodyText } from '../Text/Heading';
import BigPointNote from '../BigPointNote';

import SearchInput from './SearchInput';
import {
  loyaltyPointSearchProps,
  bigPointNoteProps,
} from './LoyaltyPointSearch.propTypes';

const OPACITY_FOR_DISABLED = 0.5;
const LIGHT_BOX_SHADOW = '0px 1px 4px rgba(0, 0, 0, 0.16)';

const LoyaltyPointSearch = props => {
  const {
    disabled,
    title,
    subtitle,
    label,
    searchLabel,
    onSearchClick,
    invalidError,
    customError,
    initialValue,
    wrapperStyle,
    isEnableNewBrandLogo,
    noteMsg,
    move,
  } = props;
  const opacity = disabled ? OPACITY_FOR_DISABLED : 1;
  const mainWrapperProps = {
    width: 1,
    boxShadow: ['none', LIGHT_BOX_SHADOW],
    borderRadius: 4,
    py: 4,
    px: [0, 4],
    my: 4,
    mx: [0, 2],
    opacity,
    ...wrapperStyle,
  };
  const searchInputProps = {
    label,
    onSearchClick,
    invalidError,
    customError,
    searchLabel,
    initialValue,
  };
  const titleFontWeight = disabled ? 400 : 500;
  const subtitleProps = {
    color: 'greyDark',
    mt: 2,
    fontSize: [0, 1],
    lineHeight: [1.5, 1.571],
  };

  return (
    <Wrapper className="loyalty-point-search" {...mainWrapperProps}>
      <Row
        alignItems={['', 'center']}
        flexDirection={['column-reverse', 'row']}
      >
        <Wrapper flex="1">
          <SubBodyText
            className="loyalty-point-title"
            color="greyDarker"
            fontWeight={titleFontWeight}
          >
            {title}
          </SubBodyText>
          {!disabled && (
            <SubBodyText className="loyalty-point-sub-title" {...subtitleProps}>
              {subtitle}
            </SubBodyText>
          )}
        </Wrapper>
        <Image
          src={isEnableNewBrandLogo ? bigRewards : bigLoyalty}
          width="min-content"
          my={[3, 0]}
          alt="loyalty-icon"
          maxWidth={'95px'}
        />
      </Row>
      {!disabled && (
        <>
          <SearchInput
            className="big-member-account"
            {...searchInputProps}
            move={move}
          />
          <BigPointNote
            noteMsg={noteMsg}
            style={{
              marginTop: '13px',
            }}
          ></BigPointNote>
        </>
      )}
    </Wrapper>
  );
};

LoyaltyPointSearch.propTypes = loyaltyPointSearchProps;
LoyaltyPointSearch.defaultProps = {
  disabled: false,
  initialValue: '',
  customError: '',
  wrapperStyle: {},
  noteMsg: '',
};
LoyaltyPointSearch.displayName = 'LoyaltyPointSearch';
BigPointNote.propTypes = bigPointNoteProps;
export default LoyaltyPointSearch;
